/**
 *
 * @param {Object} win
 * @param {String} prefParams
 * @returns
 */
const getParamsForExtraInfo = (win, prefParams) => {
	const params = [];

	if (prefParams) {
		params.push(prefParams);
	}
	if (win?.DDC?.inheritedSiteProperties?.enableGCLIDFormHiddenField) {
		params.push('gclid');
	}

	return params.length ? params.join(',').split(',') : [];
};

export default getParamsForExtraInfo;
